import { render, staticRenderFns } from "./PartChildOrders.vue?vue&type=template&id=2e7d9eb0"
import script from "./PartChildOrders.vue?vue&type=script&lang=js"
export * from "./PartChildOrders.vue?vue&type=script&lang=js"
import style0 from "./PartChildOrders.vue?vue&type=style&index=0&id=2e7d9eb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports